import { useState, useEffect } from 'react';
import ScoreService from '../../../services/score_service';
import ContactService from '../../../services/contact_service';

const formatRankingDate = (value) => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleDateString('es-CO', { month: 'short' }).replace('.', '');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day} ${month}, ${hours}:${minutes}`;
};

const Ranking = (vm) => {
  const [position, setPosition] = useState('-');
  const [dateUpdate, setDateUpdate] = useState(null)
  const [loading, setLoading] = useState(true)

    const loadRanking = async () => {
        setLoading(true)
        try {
            const userScore = await ScoreService.get(vm.userId)
            if (vm.logout(userScore)) return;
            if (userScore) {
                setDateUpdate(formatRankingDate(userScore?.LastUpdated))
                setPosition(String(userScore?.Position))
            } else {
                const count = await ContactService.getCount()
                if (vm.logout(count)) return;
                setPosition(String(count))
            }
        } catch (e) {
            vm.message(e?.message || e, "error");
        } finally {
            setLoading(false)
        }
    }
  
    useEffect(() => {if (vm.userId) loadRanking()}, [vm.userId]);

    return {
        position,
        dateUpdate,
        loading
    };
};

export default Ranking;
